import { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { finalize } from "rxjs/operators";
import { LoadingService } from "../services/loading.service";
import { IS_IN_RESOLVER_CONTEXT } from "../tokens/resolver-context.token";

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(LoadingService);
  const inResolver = req.context.get(IS_IN_RESOLVER_CONTEXT);

  if (inResolver) {
    loadingService.startLoading();
    return next(req).pipe(
      finalize(() => {
        loadingService.onRequestComplete();
      }),
    );
  }

  return next(req);
};
